import React from 'react';
interface HomepageNewsLoaderProps {
  count?: number;
}
const HomepageNewsLoader: React.FC<HomepageNewsLoaderProps> = ({
  count = 3
}) => {
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-sentry-component="HomepageNewsLoader" data-sentry-source-file="homepage-news-loader.tsx">
      {Array.from({
      length: count
    }).map((_, i) => <div key={i} className="block">
          <div className="flex flex-col h-full overflow-hidden rounded-3xl border
                       dark:border-neutral-800 w-full bg-white dark:bg-zinc-950
                       hover:shadow-md transition-shadow duration-200 cursor-pointer">
            <div className="w-full h-[350px] sm:h-[350px] bg-neutral-200 dark:bg-neutral-600 animate-pulse" />
            
            <div className="p-4 sm:p-6 flex flex-col flex-grow space-y-2">
              <div className="h-4 w-1/2 bg-neutral-200 dark:bg-neutral-600 animate-pulse" />
              <div className="h-6 w-full bg-neutral-200 dark:bg-neutral-600 animate-pulse" />
              <div className="h-3 w-3/4 bg-neutral-200 dark:bg-neutral-600 animate-pulse" />
            </div>
          </div>
        </div>)}
    </div>;
};
export default HomepageNewsLoader;